import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Quels documents faut-il pour s'inscrire ?",
    a: (
      <>
        Pour vous inscrire, vous aurez besoin des éléments suivants :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>Une photo d'identité</li>
          <li>Une pièce d'identité</li>
          <li>Un justificatif de domicile</li>
          <li>Une attestation d'hébergement (si nécessaire)</li>
          <li>L'ASSR2</li>
        </ul>
      </>
    ),
  },
  {
    q: "Quelles formations proposez-vous ?",
    a: (
      <>
        Nous proposons plusieurs formations adaptées à vos besoins :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>Permis A (moto)</li>
          <li>Permis B (voiture)</li>
          <li>Permis C</li>
          <li>Permis AM</li>
          <li>Passerelles</li>
        </ul>
      </>
    ),
  },
  {
    q: "Combien coûte une heure de conduite ?",
    a: "L'heure de conduite est à 45 € dans nos formules.",
  },
  {
    q: "Proposez-vous des facilités de paiement ?",
    a: "Oui, vous pouvez régler votre formation en plusieurs fois. Contactez-nous pour les modalités.",
  },
  {
    q: "Y a-t-il des offres ou promotions ?",
    a: (
      <>
        Oui, nos tarifs actuels sont des prix de lancement :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>20 leçons : <span className="line-through text-[#5b6577]">1 149 €</span> <span className="font-bold text-[#00a86b]">999 €</span></li>
          <li>30 leçons : <span className="line-through text-[#5b6577]">1 695 €</span> <span className="font-bold text-[#00a86b]">1 349 €</span></li>
        </ul>
      </>
    ),
  },
  {
    q: "Combien d'heures faut-il pour passer le permis ?",
    a: (
      <>
        Il n'existe aucun minimum légal obligatoire. Cependant, certaines auto-écoles proposent généralement :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>13 heures en boîte automatique</li>
          <li>20 heures en boîte manuelle</li>
        </ul>
        <p className="mt-2">Chez nous, le nombre d'heures dépend uniquement de votre niveau et de votre progression.</p>
      </>
    ),
  },
  {
    q: "Combien de temps pour obtenir une date d'examen ?",
    a: "Il n'y a pas de délai fixe. Vous pouvez être présenté à l'examen dès que vous avez validé les 4 compétences nécessaires à une conduite autonome. Certains élèves y parviennent en une vingtaine d'heures, d'autres ont besoin de plus de temps selon leur implication et leur maîtrise du code.",
  },
  {
    q: "Peut-on passer le permis rapidement ?",
    a: "Oui, nous proposons des formations accélérées (5h et 10h) selon votre niveau.",
  },
  {
    q: "Puis-je choisir mes horaires de conduite ?",
    a: "Conduite : du lundi au samedi de 7h à 22h, et le dimanche de 10h à 20h. Horaires de bureau : du lundi au vendredi de 10h à 21h, et le samedi de 10h à 18h30.",
  },
  {
    q: "Les leçons du soir sont-elles au même tarif ?",
    a: "Les leçons de conduite programmées entre 20h et 22h font l'objet d'une majoration de 5 € par heure. Pour toute question, contactez notre secrétariat au 01 41 31 50 61.",
  },
  {
    q: "Comment se déroulent les cours de conduite ?",
    a: (
      <>
        Chaque séance dure 1 heure, répartie comme suit :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>55 minutes de conduite</li>
          <li>5 minutes de bilan et conseils personnalisés</li>
        </ul>
      </>
    ),
  },
  {
    q: "Est-ce que j'aurai toujours le même moniteur ?",
    a: "Un enseignant référent vous suit tout au long de votre formation. Cependant, vous pouvez être amené à conduire avec plusieurs moniteurs pour enrichir votre apprentissage.",
  },
  {
    q: "Le code est-il inclus dans la formation ?",
    a: (
      <>
        Oui, nous proposons une plateforme e-learning à 10 €, avec :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>des cours en illimité</li>
          <li>des quiz d'entraînement</li>
        </ul>
      </>
    ),
  },
  {
    q: "À quoi sert le simulateur ?",
    a: "Le simulateur permet d'apprendre les bases de la conduite en toute sécurité, sans la pression de la route, grâce à un environnement immersif technologique.",
  },
  {
    q: "Le simulateur est-il obligatoire ?",
    a: "Non, sauf dans les formules 20 et 30 leçons, où il est inclus.",
  },
  {
    q: "Proposez-vous un suivi personnalisé ?",
    a: (
      <>
        Oui, grâce à notre plateforme e-learning, vous pouvez :
        <ul className="mt-2 space-y-1 list-disc list-inside">
          <li>suivre votre progression</li>
          <li>accéder à votre parcours</li>
          <li>vous entraîner avec des quiz</li>
        </ul>
      </>
    ),
  },
  {
    q: "Puis-je changer d'auto-école en cours de formation ?",
    a: "Oui, vous pouvez vous inscrire chez nous à tout moment. Il vous suffira de fournir votre numéro NEPH.",
  },
  {
    q: "Si j'ai raté mon examen ailleurs, combien d'heures dois-je reprendre ?",
    a: "Il n'y a pas de nombre d'heures minimum. Une évaluation de votre niveau sera réalisée afin de définir un parcours adapté.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="anchor-offset py-24 md:py-32 bg-[#f8faff]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <div className="text-[#00a86b] font-headings font-bold text-sm uppercase tracking-[0.2em]">FAQ</div>
          <h2 className="mt-3 font-headings font-black text-4xl md:text-5xl text-[#1a2332] tracking-tight">
            Vous avez des questions ?
          </h2>
          <p className="mt-4 text-[#5b6577]">Les réponses aux 17 questions les plus fréquentes de nos élèves.</p>
        </div>

        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl mb-3 px-6 shadow-sm border border-black/5 data-[state=open]:border-[#00a86b]/30">
              <AccordionTrigger data-testid={`faq-item-${i}`} className="font-headings font-bold text-[#1a2332] hover:no-underline text-left py-5 data-[state=open]:text-[#00a86b]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5b6577] leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
